import Vue from "vue";
import { listarValores } from "./api";

/**
 * Codigo (coluna `nome` da tabela `valores`) usado por cada propriedade do mixin global.
 */
export const CODIGOS_VALORES = {
  valorRevenda: "loja",
  valorFiscal: "fiscal",
  valorGamaZap: "gamazap",
  valorGamaZapCampanhas: "gamazap-campanhas",
  valorSuporte: "suporte-dedicado",
  valorGtef: "g-tef",
  valorGtefSitef: "g-tef-sitef",
  valorGtefScope: "g-tef-scope",
  valorGpos: "g-pos",
  valorGmesas: "g-mesas",
  valorGtotem: "g-totem",
  valorRobo: "robo-atendimento",
  valorMinimoRevenda: "revenda-valor-minimo",
  valorMinimoFatura: "revenda-valor-minimo-com-desconto",
  qtdMinimoLojasRevenda: "revenda-qtd-minima-lojas",
};

const estado = Vue.observable({
  valores: {},
  lista: [],
});

let carregamento = null;

export const getValor = (codigo) => Number(estado.valores[codigo]) || 0;

export const getListaValores = () => estado.lista;

/**
 * Busca os valores no master uma unica vez (forcar = true busca de novo, ex.: depois de salvar).
 * Falha se algum codigo usado pelo painel nao vier, pra nao calcular cobranca com zero.
 */
export const carregarValores = (forcar = false) => {
  if (!carregamento || forcar) {
    carregamento = listarValores()
      .then(({ data: resposta }) => {
        const lista = Array.isArray(resposta?.data) ? resposta.data : [];
        const valores = {};
        lista.forEach(({ nome, valor }) => {
          valores[nome] = Number(valor);
        });

        const faltando = Object.values(CODIGOS_VALORES).filter((codigo) => !(codigo in valores));
        if (faltando.length) {
          throw new Error(`Valores não cadastrados: ${faltando.join(", ")}.`);
        }

        estado.valores = valores;
        estado.lista = lista;
        return valores;
      })
      .catch((error) => {
        carregamento = null;
        throw new Error(error?.response?.data?.message || error.message);
      });
  }

  return carregamento;
};
